import { React, Component, useEffect } from 'react';
import { APIProvider, Map, AdvancedMarker, useMarkerRef, Pin, useMapsLibrary, InfoWindow, useMap } from '@vis.gl/react-google-maps';

const TripMap = (props) => {
    const [markerRef, marker] = useMarkerRef();
    /* const map = useMap(); */
    var coordinates_lat = parseFloat(0.0);
    var coordinates_lng = parseFloat(0.0);
    var zoom = 3;


    /* useEffect(() => {
        if (!map) {
            return;
        }
        // do something with map instance here
    }, [map]); */


    try {
        if (props.activity_selected && props.data.length >= 1) {
            for (const segment of props.data) {
                for (const activity of segment.activities) {
                    if (props.activity_selected == (segment.order * 1000 + activity.order)) {
                        coordinates_lat = parseFloat(activity.coordinates_lat);
                        coordinates_lng = parseFloat(activity.coordinates_lng);
                        zoom = 10;
                    }
                }
            }
        } else if (props.data.length >= 1) {
            coordinates_lat = parseFloat(props.data[0].activities[0].coordinates_lat);
            coordinates_lng = parseFloat(props.data[0].activities[0].coordinates_lng);
            zoom = 10;
        }

    } catch (err) {
        console.log("No activities to display");
    }


    return (
        <APIProvider apiKey={"AIzaSyBJ6Rx7IshzXH89xxY5zEZ17lsozTjwgy8"}>
            <Map
                className={"trip__map-inner"}
                defaultZoom={zoom}
                zoom={zoom > 10 ? zoom : null}
                defaultCenter={{ lat: coordinates_lat, lng: coordinates_lng }}
                gestureHandling={"greedy"}
                mapId={"trip_map"}
            >
                {props.data.length >= 1 &&
                    props.data.map((segment, i) => (
                        segment.activities.map((activity, index) => (
                            activity.coordinates_lat && (
                                <AdvancedMarker
                                    key={index}
                                    className={"trip__map__marker"}
                                    title={"Trip map"}
                                    ref={props.activity_selected == (segment.order * 1000 + activity.order) ? markerRef : null}
                                    position={{ lat: parseFloat(activity.coordinates_lat), lng: parseFloat(activity.coordinates_lng) }}
                                    onClick={() => props.selectMapMarker(segment.order * 1000 + activity.order)}
                                >
                                    {props.activity_selected == (segment.order * 1000 + activity.order) &&
                                        <Pin background={"#aa5375"} glyphColor={"#fbfcfb"} borderColor={"#fbfcfb"} />
                                    }
                                    {props.activity_selected != (segment.order * 1000 + activity.order) &&
                                        <Pin background={"#a98f99"} glyphColor={"#fbfcfb"} borderColor={"#fbfcfb"} />
                                    }
                                </AdvancedMarker>
                            )
                        ))
                    ))
                }

                {props.data.length >= 1 &&
                    props.data.map((segment, i) => (
                        segment.activities.map((activity, index) => (
                            props.activity_selected == (segment.order * 1000 + activity.order) && (
                                < InfoWindow
                                    key={index}
                                    anchor={marker}
                                >
                                    <p className="trip__map__infowindow text-bold text-color-secondary">
                                        {activity.label}
                                    </p>
                                </InfoWindow>
                            )
                        ))
                    ))
                }

            </Map>
        </APIProvider >
    );
};

export default TripMap;